export default __webpack_public_path__ + "static/media/image8.2c66f458.jpg";